import React from 'react'

// bootstrap
import { Modal } from 'react-bootstrap'

// styles
import './styles/info-modal-styles.scss'

// includes
import ModalContent from './includes/ModalContent'

export default function InfoModal(props) {
    // props
    const {
        modalType, // required: type of the modal: modal_confirm && modal_info.
        modalVisibility, // required: determine modal visibility either true or false
        onHide, // required to hide the modal

        modalTitle, // required: show the title
        modalDescription, // shows the description

        confirmBtnText, // works only if the modalType is modal_confirm: text for confirm btn. default is "Confirm Action"
        cancelBtnText, // works only if the modalType is modal_confirm: text for cancel btn. default is "Confirm Action"

        confirmAction // required when the modalType is modal_confirm: function to tell the user action either confirm or cenceled
    } = props

    // when confirm button is pressed
    const handleConfirmBtnPress = ev => {
        ev.preventDefault()

        // sending action back to main component
        confirmAction(true)
    }

    // when confirm button is pressed
    const handleCancelBtnPress = ev => {
        ev.preventDefault()

        // sending action back to main component
        confirmAction(false)
    }

    return (
        <Modal show={modalVisibility} onHide={onHide} centered className="st-info-modal">
            <Modal.Body className="st-modal">
                <ModalContent
                    modalType={modalType}

                    closeModal={onHide}

                    modalTitle={modalTitle}
                    modalDescription={modalDescription}

                    confirmBtnText={confirmBtnText}
                    cancelBtnText={cancelBtnText}

                    handleConfirmBtnPress={ev => handleConfirmBtnPress(ev)}
                    handleCancelBtnPress={ev => handleCancelBtnPress(ev)}
                />
            </Modal.Body>
        </Modal>

    )
}
